"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icons = require("@ant-design/icons");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

const SideBarToggleButton = props => {
  const {
    collapsed,
    toggleCallback
  } = props;

  if (collapsed) {
    return /*#__PURE__*/_react.default.createElement(_icons.MenuUnfoldOutlined, {
      onClick: toggleCallback,
      style: {
        fontSize: '24px',
        cursor: 'hand',
        color: 'white'
      }
    });
  }

  return /*#__PURE__*/_react.default.createElement(_icons.MenuFoldOutlined, {
    onClick: toggleCallback,
    style: {
      fontSize: '24px',
      cursor: 'hand',
      color: 'white'
    }
  });
};

SideBarToggleButton.propTypes = {
  collapsed: _propTypes.default.bool.isRequired,
  toggleCallback: _propTypes.default.func.isRequired
};
var _default = SideBarToggleButton;
exports.default = _default;